<template>
  <button :type="type" class="tm-form-button" @click="handleClick">
    {{ label }}
  </button>
</template>

<script>
export default {
  name: "tm-button",
  props: {
    name: {
      type: String,
    },
    type: {
      type: String,
      default: "submit",
    },
    label: {
      type: String,
      default: "",
    },
    // 按钮接口
    r: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleClick(event) {
      // 如果是 submit 类型，阻止默认的表单提交行为
      if (this.type === "submit") {
        event.preventDefault();
        this.$emit("submit", this.r);
      } else {
        this.$emit("click", this.r);
      }
    },
  },
};
</script>

<style scoped>
.tm-form-button {
  padding: 0 20px;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: #3498db;
  color: white;
}

.tm-form-button:hover:not(:disabled) {
  background-color: #2980b9;
}

.tm-form-button:disabled {
  background-color: #bdc3c7;
  cursor: not-allowed;
}
</style>
